import { injectable } from 'inversify';
import { getClientUniqueId } from './engine/analyticsApiClient/helper';

export interface ClientMetaPayload {
  peerId?: string;
  channelId?: string;
  appId?: string;
  datacenterName?: string;
  nodeId?: string;
  clUId: string;
  [key: string]: unknown;
}

@injectable()
export class ClientMetaProvider {
  #peerId?: string;

  #channelId?: string;

  #appId?: string;

  #datacenterName?: string;

  #nodeId?: string;

  #externalMeta: Record<string, unknown> = {};

  get meta(): ClientMetaPayload {
    return {
      clUId: getClientUniqueId(),
      ...this.#externalMeta,
      peerId: this.#peerId,
      channelId: this.#channelId,
      appId: this.#appId,
      datacenterName: this.#datacenterName,
      nodeId: this.#nodeId,
    };
  }

  setPeerId(id: string): void {
    this.#peerId = id;
  }

  setChannelId(id: string): void {
    this.#channelId = id;
  }

  setAppId(id: string): void {
    this.#appId = id;
  }

  setDatacenterName(name: string): void {
    this.#datacenterName = name;
  }

  setNodeId(id: string): void {
    this.#nodeId = id;
  }

  setExternalMeta(meta: Record<string, unknown>): void {
    this.#externalMeta = meta;
  }

  clear(): void {
    this.#peerId = undefined;
    this.#channelId = undefined;
    this.#appId = undefined;
    this.#datacenterName = undefined;
    this.#externalMeta = {};
  }
}
